import z from "zod";

/**
 * Schema for updating a product
 */
export const updateProductSchema = z.object({
  id: z.number({ message: "ID é obrigatório para atualização" }),
  code: z.number({ message: "Código é obrigatório" }),
  name: z.string({ message: "Nome é obrigatório" }).min(1, "Nome não pode estar vazio"),
  group: z.number({ message: "Grupo é obrigatório" }),
  ncmcode: z.string({ message: "Código NCM é obrigatório" })
});
